import { KycStatusCheckListingFilters } from "./types";

export type KycStatusCheckStatusFilter = "compliant" | "non_compliant";

export const kycStatusCheckStatusOptions: {
  id: string;
  label: string;
  value: KycStatusCheckStatusFilter;
}[] = [
  { id: "compliant", label: "Compliant", value: "compliant" },
  { id: "non_compliant", label: "Non compliant", value: "non_compliant" },
];

export const filterNameDisplayLabelMapping: Partial<
  Record<keyof KycStatusCheckListingFilters, string>
> = {
  status: "status",
};
